import { ILayoutProduct, ProductSection } from "lib";

export function getLayoutProductIds(
    sections: Array<Pick<ProductSection, "buttons">>
): ILayoutProduct["id"][] {
    const productIds = new Set<ILayoutProduct["id"]>();

    sections.forEach(section => {
        section.buttons.forEach(button => {
            if (button.buttonType === "PRODUCT") {
                productIds.add(button.productId);
                return;
            }

            if (button.buttonType === "MULTI_PRODUCT") {
                button.productIds.forEach(item => {
                    productIds.add(item.id);
                });
            }
        });
    });

    return [...productIds];
}
